<section>
  <h2><span class="sub">姉妹店</span>小野治療院こころtoからだ</h2>
  <ul fxLayout="row wrap" fxLayoutAlign="center start">
    <li class="website">
      <a href="https://peraichi.com/landing_pages/view/onoeiichi" rel="noopener noreferrer" target="_blank">
        <div class="thumbnail">
          <img src="/assets/img/kokoro_to_karada.jpg" alt="こころtoからだ">
        </div>
        <div class="label">
          治療に対する思い
        </div>
      </a>
    </li>
    <li class="hotpepper">
      <a href="https://beauty.hotpepper.jp/kr/slnH000452802/" rel="noopener noreferrer" target="_blank">
        <div class="thumbnail" fxLayout="column" fxLayoutAlign="center center">
          <img src="/assets/img/logo_hotpepper.svg" alt="ホットペッパー 予約">
        </div>
        <div class="label">
          ネット予約
        </div>
      </a>
    </li>
    <li class="ameblo">
      <a href="https://ameblo.jp/onoeiichi/" rel="noopener noreferrer" target="_blank">
        <div class="thumbnail" fxLayout="column" fxLayoutAlign="center center">
          <span>Ameblo</span>
        </div>
        <div class="label">
          ブログ
        </div>
      </a>
    </li>
  </ul>
  <div class="reserve" fxLayout="row" fxLayoutAlign="center center">
    <p fxLayout="row" fxLayoutAlign="center center">
      <span>ご予約、お問合せ</span>
      <a href="tel:017-718-8830" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon fontSet="material-icons-outlined">phone</mat-icon>
        <span>017-718-8830</span>
      </a>
    </p>
  </div>
</section>